import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  DatePicker,
  Input,
  message,
  Row,
  Spin,
  Table,
  Select,
} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import DynamicSelectOption from '../../components/DynamicSelectOption/DynamicSelectOption';
import { useEffect, useState } from 'react';
import { API, BEARER } from '../../constant';
import { getToken } from '../../helpers';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import { toProperCase } from '../../utils/generic';
import { errorHandler } from '../../utils/errorHandling';

const filterGlobalSearch = (Data, searchText, filterScope) => {
  if (!searchText) {
    return Data;
  }

  let filteredDataTemp = [];
  if (filterScope == 'all') {
    filteredDataTemp = Data.filter((value) => {
      console.log(value);
      return (
        value?.seasonType
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        value?.seasonYear
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        value?.season_id
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase())
      );
    });
  } else if (filterScope == 'seasonName') {
    filteredDataTemp = Data.filter((value) => {
      return value?.season_id
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'seasonYear') {
    filteredDataTemp = Data.filter((value) => {
      return value?.seasonYear
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'seasonType') {
    filteredDataTemp = Data.filter((value) => {
      return value.seasonType
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  }

  console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
  if (filteredDataTemp?.length > 0) {
    return filteredDataTemp;
  } else {
    filteredDataTemp.push({
      key: 0,
      id: 0,
      seasonType: 'NA',
      seasonYear: 'NA',
      season_id: 'NA',
    });
    return filteredDataTemp;
  }
};

const SessionManagement = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  // Edit Data For editing Existing Record
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const authToken = getToken();
  const [Data, setData] = useState([]);
  const [designform] = Form.useForm();
  const [showForm, setShowForm] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const dateFormat = 'YYYY-MM-DD';
  const [optionList, setOptionList] = useState([]);

  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');

  const [searchText, setSearchText] = useState('');
  const [filterScope, setFilterScope] = useState('all');

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);

  const [seasonName, setSeasonName] = useState('');
  const filterScopeOptionsArray = [
    'all',
    'seasonName',
    'seasonYear',
    'seasonType',
  ];

  // search table
  const handleSearch = async (event) => {
    console.log(event);
    globalSearch(searchInput);
  };

  const globalSearch = async (searchValue) => {
    if (searchValue === '') {
      fetchData(getToken());
    } else {
      setIsLoading(true);
      let data1 = [];
      try {
        const response = await fetch(
          `${API}/seasons?filters[$or][0][seasonType][$containsi]=${searchValue}&filters[$or][1][season_id][$containsi]=${searchValue}&pagination[page]=1&pagination[pageSize]=${pageSize}&sort=createdAt:desc`,
          {
            headers: { Authorization: `${BEARER} ${getToken()}` },
          }
        );
        const designMasterData = await response.json();

        data1 = designMasterData.data.map((entry) => {
          return {
            id: entry.id,
            seasonType: entry.attributes.seasonType,
            seasonYear: entry.attributes.seasonYear,
            season_id: entry.attributes.season_id,
          };
        });
        console.log('original Data:', designMasterData);
        console.log('Data:', data1);
        setData(data1);

        setTotal(designMasterData.meta.pagination.total);
        setPageSize(designMasterData.meta.pagination.pageSize);
        setPageCount(designMasterData.meta.pagination.pageCount);
      } catch (error) {
        console.error(error);
        message.error('Error while fetching Data!');
      } finally {
        setIsLoading(false);
      }
    }
  };

  // search table

  const onPageChange = async (page) => {
    setIsLoading(true);
    console.log(page, pageSize);
    setCurrent(page);

    let data2 = [];
    try {
      const pagin_response = await fetch(
        `${API}/seasons?pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${getToken()}` },
        }
      );
      const paginationData = await pagin_response.json();

      data2 = paginationData.data.map((entry) => {
        return {
          id: entry.id,
          seasonType: entry.attributes.seasonType,
          seasonYear: entry.attributes.seasonYear,
          season_id: entry.attributes.season_id,
        };
      });
      console.log('original Data:', paginationData);
      console.log('Data:', data2);
      setData(data2);
      // let page = paginationData.meta.pagination.page;

      setTotal(paginationData.meta.pagination.total);
      setPageSize(paginationData.meta.pagination.pageSize);
      setPageCount(paginationData.meta.pagination.pageCount);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  let data1 = [];

  const fetchDesignMaster = async (token) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API}/seasons?pagination[page]=1&pagination[pageSize]=${pageSize}&sort=createdAt:desc`,
        {
          headers: { Authorization: `${BEARER} ${token}` },
        }
      );
      const designMasterData = await response.json();

      data1 = designMasterData.data.map((entry) => {
        return {
          id: entry.id,
          seasonType: entry.attributes.seasonType,
          seasonYear: entry.attributes.seasonYear,
          season_id: entry.attributes.season_id,
        };
      });
      console.log('original Data:', designMasterData);
      console.log('Data:', data1);
      setData(data1);

      setTotal(designMasterData.meta.pagination.total);
      setPageSize(designMasterData.meta.pagination.pageSize);
      setPageCount(designMasterData.meta.pagination.pageCount);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const getUserdDetails = async (entry) => {
    const userDetailsResponse = await fetch(
      `${API}/auditlogs?filters[$and][0][contentType][$eq]=seasons&filters[$and][0][activity][$eq]=create&filters[$and][0][urlEndPoint][$eq]=/api/seasons/${entry?.id}&sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      }
    );
    const userDetailsResponseData = await userDetailsResponse.json();
    console.log(
      userDetailsResponseData,
      'userDetailsResponse check',
      'Season Details',
      entry?.id
    );

    return {
      userRefId: userDetailsResponseData?.data[0]?.attributes?.user?.id,
      userName: userDetailsResponseData?.data[0]?.attributes?.user?.username,
      userEmail: userDetailsResponseData?.data[0]?.attributes?.user?.email,
    };
  };

  const getUserdDetailsCreatedBy = async (entry, contentTypeName) => {
    const userDetailsResponse = await fetch(
      `${API}/auditlogs?filters[$and][0][contentType][$eq]=${contentTypeName}&filters[$and][0][activity][$eq]=create&filters[$and][0][resourceId][$eq]=${entry?.id}&sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      }
    );
    const userDetailsResponseData = await userDetailsResponse.json();
    console.log(
      userDetailsResponseData,
      'userDetailsResponse check',
      'Season Details',
      entry?.id
    );

    return {
      userRefId: userDetailsResponseData?.data[0]?.attributes?.user?.id,
      userName: userDetailsResponseData?.data[0]?.attributes?.user?.username,
      userEmail: userDetailsResponseData?.data[0]?.attributes?.user?.email,
    };
  };

  const fetchData = async (token) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/seasons?sort=createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const responseData = await response.json();
      console.log(responseData, 'response check');
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        // return;

        data1 = await Promise.all(
          responseData?.data?.map(async (entry) => {
            // Fetch User Details
            const userDetails = await getUserdDetailsCreatedBy(
              entry,
              'seasons'
            );
            // End Fetch User Details
            return {
              key: entry?.id,
              id: entry?.id,
              seasonType: entry.attributes.seasonType,
              seasonYear: entry.attributes.seasonYear,
              season_id: entry.attributes.season_id,
              userDetails: userDetails,
              createdAt: entry?.attributes?.createdAt,
              updatedAt: entry?.attributes?.updatedAt,
            };
          })
        );

        console.log('original Season Data:', responseData);
        console.log('Season Data after modification:', data1);
        // setData(await sortRecordsByMonth(data1, true));
        setData(filterGlobalSearch(data1, searchText, filterScope));
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (authToken) {
      // fetchDesignMaster(authToken);
      fetchData(authToken);
      // fetchSesson(authToken);
    }
  }, []);

  useEffect(() => {
    console.log(editData);
    designform.setFieldsValue(editData);
  }, [editData, designform]);

  useEffect(() => {
    // console.log(searchText);
    if (searchText == '') {
      fetchData(authToken);
    } else {
      fetchData(authToken);
    }
  }, [searchText, filterScope]);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    designform.resetFields();
    setEditData(null);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    designform.resetFields();
    setEditData(null);
    setIsModalOpen(false);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const seasonObject = {
    spring: 2,
    summer: 3,
    monsoon: 6,
    autumn: 10,
    'pre-winter': 11,
    winter: 12,
  };

  const addNewProductSpecification = async (data) => {
    setSaving(true);

    console.log(
      data.seasonYear,
      seasonObject[data.seasonType],
      data.seasonYear.format('YYYY-MM-DD'),
      data.seasonYear.format('YYYY'),

      new Date(data.seasonYear, 3, 1),
      new Date(data.seasonYear.format('YYYY'), 3, 1),
      moment(
        new Date(
          data.seasonYear.format('YYYY'),
          seasonObject[data.seasonType],
          1
        )
      ).format('YYYY-MM-DD')
    );

    const values = {
      ...data,
      seasonYear: moment(
        new Date(
          data?.seasonYear?.format('YYYY'),
          seasonObject[data?.seasonType],
          1
        )
      ).format('YYYY-MM-DD'),
    };

    // delete values["Date"];

    data = { data: values };

    console.log('data:', data);
    console.log('values:', values);
    // return;

    console.log('data edit:', data.data.editId);

    if (data.data.editId) {
      console.log('edit id :', data.data.editId);

      try {
        const response = await fetch(`${API}/seasons/${data.data.editId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          if (responseData?.errorInfo?.status == 403) {
            message.error(
              'Unable to Process your Request, ' + responseData.error
            );
          } else {
            message.error('Something went wrong, please try again');
          }
        } else {
          message.success('Data saved successfully!');
          fetchData(getToken());
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        handleOk();
      }
    } else {
      console.log('edit id :', data.editId);

      try {
        const response = await fetch(`${API}/seasons/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          if (responseData?.errorInfo?.status == 403) {
            message.error(
              'Unable to Process your Request, ' + responseData.error
            );
          } else {
            message.error('Something went wrong, please try again');
          }
        } else {
          message.success('Data saved successfully!');
          fetchData(getToken());
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Updating the Data!');
      } finally {
        setSaving(false);
        handleOk();
      }
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    // This is for Handling Dynamic Values.
    console.log('Changed values:', changedValues);
    console.log('All values:', allValues);

    let selectedSeason = changedValues?.seasonType || allValues?.seasonType;
    let selectedYear = changedValues?.seasonYear || allValues?.seasonYear;

    console.log('testing --- ', selectedSeason, selectedYear);
    if (selectedSeason || selectedYear) {
      if (selectedSeason == 'autumn') {
        console.log(`AW${selectedYear?.format('YY')}`, '340');
        designform?.setFieldsValue({
          season_id: `AW${selectedYear?.format('YY')}`,
        });
      } else if (selectedSeason == 'summer') {
        console.log(`SS${selectedYear?.format('YY')}`, '346');
        designform?.setFieldsValue({
          season_id: `SS${selectedYear?.format('YY')}`,
        });
      }
    }
  };

  const columns = [
    {
      key: 'seasonType',
      title: 'Season Type',
      dataIndex: 'seasonType',
    },
    {
      key: 'season_id',
      title: 'season Name',
      dataIndex: 'season_id',
    },
    {
      key: 'seasonYear',
      title: 'season year',
      dataIndex: 'season_year',
      render: (_, record) => {
        console.log(
          record,
          record?.seasonYear,
          moment(record?.seasonYear).format('YYYY')
        );
        return record?.seasonYear == 'NA'
          ? 'NA'
          : moment(record?.seasonYear).format('YYYY') ?? 'Invalid Year';
      },
    },
    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },
    {
      key: 'createdAt',
      title: 'Created-Date',
      dataIndex: 'createdAt',
      render: (_, record) => {
        // console.log(record, record?.userDetails?.userName);
        return moment(record?.createdAt).format('DD/MM/YYYY') ?? 'NA';
      },
    },

    {
      key: 'action',
      title: 'Actions',
      render: (record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />
              <DeleteOutlined
                hidden={false}
                style={{ color: 'red' }}
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const deleteDesignMasterEntry = async (recordID) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/seasons/${recordID}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
      });
      const responseData = await response.json();
      console.log(responseData);
      if (responseData.error) {
        errorHandler(responseData, message);
      } else {
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  const Delete = (record) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this',
      onOk: () => {
        deleteDesignMasterEntry(record.id);

        // setData((pre) => {
        //   return pre.filter((person) => person.id != record.id);
        // });
      },
    });
  };

  const Edit = (record) => {
    setEditData({
      seasonType: record.seasonType,
      seasonYear: moment(record.seasonYear, 'YYYY'),
      season_id: record.season_id,
      editId: record.id,
    });

    showModal();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
  };

  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText('');
    setFilterScope('all');
    setAlreadySelectedRows([]);
    fetchData(authToken);
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  }; // handle change in filter scope

  const getFilterOptionArray = (options) => {
    return options.map((option) => {
      return { value: option, label: option };
    });
  }; //

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const getFormattedData = () => {
    const downloadData = Data;
    // console.log(downloadData, 'downloading data...');

    let downloadDataFormatted = downloadData?.map((row) => {
      // console.log(row, 'downloading data row...');
      return {
        id: row.id,
        seasonType: row?.seasonType,
        seasonYear:
          row?.seasonYear == 'NA'
            ? 'NA'
            : moment(row?.seasonYear).format('YYYY') ?? 'Invalid Year',
        season_id: row?.season_id,
        userName: row?.userDetails?.userName,
        CreatedDate: moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',
      };
    });

    // console.log(downloadDataFormatted, 'downloading data 2...');
    return downloadDataFormatted;
  };

  return (
    <div>
      <div>Season Management</div>

      <Button onClick={showModal}>Add New Season</Button>

      <div className="table">
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              disabled={true}
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button onClick={resetTable}>Reset</Button>
            <Button style={{ backgroundColor: 'greenyellow', color: 'white' }}>
              <CSVLink
                data={getFormattedData()}
                filename={
                  'Season-Master-list-' +
                  moment(new Date()).format('DD-MM-YYYY')
                }
              >
                Download
              </CSVLink>
            </Button>
          </div>
        </div>
        {isLoading ? (
          <Spin size="large" />
        ) : (
          <Table
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{ position: ['bottomCenter'] }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [Table.SELECTION_NONE, Table.SELECTION_ALL],
            }}
          />
        )}
      </div>

      <Modal
        title="Add New Season"
        visible={isModalOpen}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
      >
        <Card className="addProduct_page_card">
          <Form
            form={designform}
            layout="vertical"
            onFinish={addNewProductSpecification}
            onValuesChange={handleValuesChange}
          >
            <Row gutter={[16, 16]}>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Season Category"
                  name="seasonType"
                  rules={[
                    {
                      required: true,
                      message: 'Season category Required!',
                      type: 'string',
                    },
                  ]}
                >
                  <Select placeholder="Select">
                    <Select.Option value="summer">Summer</Select.Option>
                    <Select.Option value="autumn">Autumn</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Season Year"
                  name="seasonYear"
                  rules={[
                    {
                      required: true,
                      message: 'Season Year is Required!',
                      type: 'object',
                    },
                  ]}
                >
                  <DatePicker picker="year" />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Season Name"
                  name="season_id"
                  rules={[
                    {
                      type: 'string',
                      required: true,
                    },
                  ]}
                >
                  <Input value={seasonName} />
                </Form.Item>
              </Col>

              <Form.Item label="" hidden={true} name="editId">
                <Input type="text" />
              </Form.Item>
            </Row>
            <Button
              className="addProduct_save_btn"
              htmlType="submit"
              type="primary"
              size="large"
            >
              {saving ? (
                <>
                  <Spin size="small" /> Saving
                </>
              ) : (
                'Save'
              )}
            </Button>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};

export default SessionManagement;
